module.exports = __webpack_public_path__ + "img/03.38798afa.jpg";